import { GET_LOYALTY_REWARDS_PER_LEVEL, UPDATE_LOYALTY, UPDATE_LOYALTY_REWARDS } from "./types";

export const updateLoyaltySettings = (formData) => async (dispatch, getState) => {
	const {
		databasesRef: { adminDB },
	} = getState().auth;

	const location = `loyaltySettings.${formData.level}`;

	try {
		await adminDB.update({
			[location]: formData.values,
		});
		dispatch({ type: UPDATE_LOYALTY, payload: { [formData.level]: formData.values } });
		alert("Se actualizó con exito");
	} catch (error) {
		alert("Ocurrio un error");
	}
};

export const syncLoyalty = () => async (dispatch, getState) => {
	const {
		databasesRef: { adminDB },
	} = await getState().auth;

	if (!adminDB) return;

	try {
		const data = await adminDB.get();
		const payload = data.data();
		dispatch({
			type: UPDATE_LOYALTY,
			payload: payload.loyaltySettings,
		});
	} catch (error) {
		console.log(error);
		alert("Ocurrio un error al obtener la informacion");
	}
};

export const addLoyaltyReward = (reward, callback) => async (dispatch, getState) => {
	const {
		databasesRef: { loyaltyRewards, nameDB },
	} = await getState().auth;

	if (!loyaltyRewards) return;

	try {
		const rewardWithStoreName = { ...reward, store: nameDB };
		await loyaltyRewards.doc().set(rewardWithStoreName);
		if (callback) callback();
	} catch (error) {
		console.log(error);
		alert("Ocurrio un error al obtener la informacion");
	}
};

export const AddRewardToLevel = ({ reward, level }, callback) => async (dispatch, getState) => {
	const {
		databasesRef: { loyaltyRewardsPerLevel },
	} = await getState().auth;

	if (!loyaltyRewardsPerLevel) return;

	const { rewardsPerLevel } = await getState().loyalty;

	try {
		const updatedRewards = [...rewardsPerLevel[level], reward];
		await loyaltyRewardsPerLevel.set({ [level]: updatedRewards }, { merge: true });
		if (callback) callback();
	} catch (error) {
		console.log(error);
		alert("Ocurrio un error al obtener la informacion");
	}
};

export const getLoyaltyRewardsPerLevel = () => async (dispatch, getState) => {
	const {
		databasesRef: { loyaltyRewardsPerLevel },
	} = await getState().auth;

	if (!loyaltyRewardsPerLevel) return;

	try {
		const response = await loyaltyRewardsPerLevel.get();
		const payload = response.data();

		dispatch({
			type: GET_LOYALTY_REWARDS_PER_LEVEL,
			payload,
		});
	} catch (error) {
		console.log(error);
		alert("Ocurrio un error al obtener la informacion");
	}
};

export const syncLoyaltyRewards = () => async (dispatch, getState) => {
	const {
		databasesRef: { loyaltyRewards },
	} = await getState().auth;

	try {
		const response = await loyaltyRewards.get();
		let payload = [];
		for (const doc of response.docs) {
			payload = [...payload, { ...doc.data(), _id: doc.id }];
		}

		dispatch({
			type: UPDATE_LOYALTY_REWARDS,
			payload,
		});
	} catch (error) {
		console.log(error);
		alert("Ocurrio un problema al obtener los premios desde la base de datos");
	}
};

export const deleteReward = (id, callback) => async (dispatch, getState) => {
	const {
		databasesRef: { loyaltyRewards },
	} = await getState().auth;

	try {
		await loyaltyRewards.doc(id).delete();
		callback();
	} catch (error) {
		alert("Ha ocurrido un error al eliminar este premio");
	}
};

export const deleteRewardFromLevel = ({ level, index }, callback) => async (dispatch, getState) => {
	const {
		databasesRef: { loyaltyRewardsPerLevel },
	} = await getState().auth;

	const { rewardsPerLevel } = await getState().loyalty;

	try {
		const rewards = [...rewardsPerLevel[level].slice(0, index), ...rewardsPerLevel[level].slice(index + 1)];
		console.log(level, rewards);
		await loyaltyRewardsPerLevel.update({ [level]: rewards });
		callback && callback();
	} catch (error) {
		alert("Ocurrio un error.");
		console.log(error);
	}
};
